import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.function.name";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import { formatMemory, formatTime } from './format-utils';
import { Stats } from '@probe.gl/stats';
var DEFAULT_CSS = {
  css: {
    position: 'fixed',
    zIndex: 10000,
    color: '#ccc',
    background: '#000',
    fontFamily: 'Helvetica,Arial,sans-serif',
    padding: '8px',
    fontSize: '12px',
    lineSpacing: 6
  },
  headerCSS: {
    fontSize: '16px'
  },
  itemCSS: {
    paddingLeft: '8px'
  }
};
export var DEFAULT_FORMATTERS = {
  count: function count(stat) {
    return "".concat(stat.name, ": ").concat(stat.count);
  },
  averageTime: function averageTime(stat) {
    return "".concat(stat.name, ": ").concat(formatTime(stat.getAverageTime()));
  },
  totalTime: function totalTime(stat) {
    return "".concat(stat.name, ": ").concat(formatTime(stat.time));
  },
  fps: function fps(stat) {
    return "".concat(stat.name, ": ").concat(Math.round(stat.getHz()), "fps");
  },
  memory: function memory(stat) {
    return "".concat(stat.name, ": ").concat(formatMemory(stat.count));
  }
};

var StatsWidget = function () {
  function StatsWidget(stats) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, StatsWidget);

    this.stats = stats;
    this.title = options.title;
    this._framesPerUpdate = Math.round(Math.max(options.framesPerUpdate || 1, 1));
    this._formatters = DEFAULT_FORMATTERS;
    this._resetOnUpdate = {};
    this._counter = 0;

    this._initializeFormatters(options);

    this._initializeUpdateConfigs(options);

    this._css = Object.assign({}, DEFAULT_CSS.css, options.css);
    this._headerCSS = Object.assign({}, DEFAULT_CSS.headerCSS, this._css.header);
    this._itemCSS = Object.assign({}, DEFAULT_CSS.itemCSS, this._css.item);
    delete this._css.header;
    delete this._css.item;
    this._container = null;
    this._header = null;
    this._items = {};

    this._createDOM(options.container);

    this._createDOMHeader();

    this._createDOMStats();
  }

  _createClass(StatsWidget, [{
    key: "setStats",
    value: function setStats(stats) {
      this.stats = stats;

      this._createDOMStats(this._container);

      this._setHeaderContent(stats.id);

      this.update();
    }
  }, {
    key: "update",
    value: function update() {
      var stats = this.stats && this.stats.stats;

      if (!stats || Object.keys(stats).length === 0) {
        return;
      }

      if (this._counter++ % this._framesPerUpdate !== 0) {
        return;
      }

      this._update();
    }
  }, {
    key: "_update",
    value: function _update() {
      var _this = this;

      this.stats.forEach(function (stat) {
        _this._createDOMItem(stat.name);

        _this._items[stat.name].innerHTML = _this._getLines(stat).join('<BR>');

        if (_this._resetOnUpdate[stat.name]) {
          stat.reset();
        }
      });
    }
  }, {
    key: "_initializeFormatters",
    value: function _initializeFormatters(options) {
      if (options.formatters) {
        for (var name in options.formatters) {
          var formatter = options.formatters[name];

          if (typeof formatter === 'string') {
            formatter = DEFAULT_FORMATTERS[formatter];
          }

          this._formatters[name] = formatter;
        }
      }
    }
  }, {
    key: "_initializeUpdateConfigs",
    value: function _initializeUpdateConfigs(options) {
      if (options.resetOnUpdate) {
        for (var name in options.resetOnUpdate) {
          this._resetOnUpdate[name] = options.resetOnUpdate[name];
        }
      }
    }
  }, {
    key: "_createDOM",
    value: function _createDOM(container) {
      if (typeof document === 'undefined' || !document) {
        return;
      }

      this._container = container;

      if (!this._container) {
        this._container = document.createElement('div');

        for (var name in this._css) {
          this._container.style[name] = this._css[name];
        }

        document.body.appendChild(this._container);
      }
    }
  }, {
    key: "_createDOMHeader",
    value: function _createDOMHeader() {
      if (!this._header) {
        this._header = document.createElement('div');

        for (var name in this._headerCSS) {
          this._header.style[name] = this._headerCSS[name];
        }

        this._container.appendChild(this._header);
      }

      this._setHeaderContent();
    }
  }, {
    key: "_setHeaderContent",
    value: function _setHeaderContent(title) {
      if (this._header) {
        this._header.innerText = title || this.title || this.stats && this.stats.id || '';
      }
    }
  }, {
    key: "_createDOMStats",
    value: function _createDOMStats() {
      var _this2 = this;

      if (this.stats instanceof Stats) {
        this.stats.forEach(function (stat) {
          _this2._createDOMItem(stat.name);
        });
      }
    }
  }, {
    key: "_createDOMItem",
    value: function _createDOMItem(statName) {
      if (!this._container) {
        return;
      }

      if (this._items[statName]) {
        return;
      }

      this._items[statName] = document.createElement('div');

      for (var name in this._itemCSS) {
        this._items[statName].style[name] = this._itemCSS[name];
      }

      this._container.appendChild(this._items[statName]);
    }
  }, {
    key: "_getLines",
    value: function _getLines(stat) {
      var formatter = this._formatters[stat.name] || this._formatters[stat.type] || DEFAULT_FORMATTERS.count;
      return formatter(this.stats.get(stat.name)).split('\n');
    }
  }]);

  return StatsWidget;
}();

export { StatsWidget as default };